import axios from 'axios'
import {useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import {useGlobalContent} from '../context/helpersProvider'
import logo from '../media/Balanz_white_logo.svg'
import validate from '../utils/validateEmail'
import expiredToken from '../utils/headerAuth'

export const ForgotPassword = () => {
  const history = useNavigate()
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')
  const handleChange = (e: any) => {
    const value = e.target.value
    setError(validate(value))
    setEmail(value)
  }

  const {setShowLoading, setShowToast} = useGlobalContent()

  const sendMail = () => {
    setShowLoading('true')
    axios
      .post('/user/recover', {
        email,
        rol: 1,
      })
      .then((json) => json.data)
      .then((datos) => {
        setShowLoading('false')
        if (datos.status === 200) {
          history('/check')
        } else {
          setShowToast({open: 'true', type: 'error', message: datos.message})
          setError(datos.message)
        }
      })
      .catch((err) => {
        setShowLoading('false')
        expiredToken(history, err, setShowToast)
        setShowToast({open: 'true', type: 'error', message: 'Something went wrong, please try again'})
      })
  }

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault(); // Evitar la recarga de la página por defecto del formulario
    sendMail();
  };
  
  return (
    <div className='columns w-row container-log'>
      <div className='logocolumn w-col w-col-4 w-col-stack'>
        <img
          src={logo}
          loading='lazy'
          alt='Balanz logo'
          width='600'
          sizes='(max-width: 479px) 63vw, (max-width: 767px) 43vw, (max-width: 991px) 36vw, 23vw'
          className='loginlogo'
        />
      </div>
      <div className='formcolumn w-col w-col-8 w-col-stack'>
        <div className='form w-form'>
          <Link to='/'>
            <span className='back-button w-inline-block' />
          </Link>
          <form id='email-form' name='email-form' data-name='Email Form' method='get' onSubmit={handleSubmit}>
            <h3 className='h2-titles'>Forgot Password?</h3>
            <p className='paragraph'>
            Enter the email address associated with your account to receive a recovery email
            </p>
            <label htmlFor='Email-2' className='field-label'>
              Email
            </label>
            <input
              type='email'
              className='text-field email w-input'
              autoFocus={true}
              maxLength={256}
              name='Email'
              onChange={handleChange}
              value={email}
              placeholder='Your email'
              autoComplete="off"
            />
            <p className='alert'>{error}</p>
            <span onClick={sendMail} className='button continue w-button'>
              Continue
            </span>
          </form>
        </div>
      </div>
    </div>
  )
}
